var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('router-link', {
    staticClass: "menu-list",
    attrs: {
      "exact": "",
      "tag": "div",
      "to": _vm.to,
      "id": _vm.id
    }
  }, [_c('i', {
    class: "fa fa-".concat(_vm.icon)
  }), _vm.getSideDrawer ? _c('span', [_vm._v(_vm._s(_vm.label))]) : _vm._e(), _c('div', {
    staticClass: "baar"
  })]);
}
var staticRenderFns = []

export { render, staticRenderFns }